import { FaPhoneAlt } from 'react-icons/fa';
import { MdOutlineMailOutline } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { SocialLinks } from './components/SocialLinks';
import NavBarMobile from './NavBarMobile';
import FeatureSelector from './components/FeatureSelector';
import {
  selectTemplateData,
  selectHeader,
} from 'legacyfrontend/redux/selectors/application-selectors';

export default function MainHeader({ isScrolled = false, hideMobileNavMenu = false }) {
  const templateDate = useSelector(selectTemplateData);
  const header = useSelector(selectHeader);

  const hasEmail = header?.emailContacto;
  const hasPhone = header?.telefonoContacto;
  const hasSocialNetworks = templateDate?.socialNetworks && templateDate.socialNetworks.length > 0;
  const hasDataElements = hasEmail || hasPhone || hasSocialNetworks;

  const contactBoxClass = `media__icons__container p-3 flex-row flex-wrap gap-3 lg:gap-4 items-center hidden lg:!flex ${hideMobileNavMenu ? 'lg:justify-end' : ''
    } ${isScrolled ? 'bg-white' : 'backdrop-blur-sm bg-white/80 rounded-lg drop-shadow-lg'}`;

  return (
    <div
      className={`mx-auto px-4 lg:px-8 ${isScrolled ? 'bg-white' : 'bg-white lg:bg-transparent'}`}
    >
      <div
        className={`header__topbar justify-between px-4 transition-all duration-300 ${isScrolled ? 'min-h-[70px]' : 'min-h-[100px]'
          }`}
      >
        <div
          className={`flex items-center ${hasDataElements ? 'lg:flex-[0_0_20%]' : 'lg:flex-[0_0_80%]'}`}
        >
          <a href='/' className='flex w-full'>
            <img
              src={header.logo}
              alt='Logo'
              className={`w-full h-auto object-contain transition-all duration-300 ${isScrolled
                ? 'max-h-[6vh] md:max-h-[8vh] py-4'
                : 'max-h-[10vh] lg:max-h-[20vh]'
                }`}
            />
          </a>
        </div>
        <div
          className={`flex flex-col gap-2 mt-4 ${!isScrolled ? 'mb-auto mt-1' : ''} ${hasDataElements ? 'lg:flex-[0_0_80%]' : 'lg:flex-[0_0_20%] lg:justify-center'}`}
        >
          <div
            className={`flex flex-wrap gap-3 lg:gap-9 items-center justify-end min-w-0 ${hasDataElements ? 'lg:justify-end' : 'lg:justify-center'
              }`}
          >
            <div className={contactBoxClass}>
              {hasEmail && (
                <div className='flex items-center gap-1'>
                  <MdOutlineMailOutline
                    className={`text-xl ${isScrolled ? 'text-gray-800' : 'text-gray-800 lg:text-gray-500'
                      }`}
                  />
                  <p
                    className={`contact__icon ${isScrolled ? 'text-gray-800' : 'text-gray-800 lg:text-gray-500'
                      }`}
                    style={{
                      textTransform: 'lowercase',
                    }}
                  >
                    {header.emailContacto}
                  </p>
                </div>
              )}
              {hasPhone && (
                <div className='flex items-center gap-1'>
                  <FaPhoneAlt
                    className={`text-base ${isScrolled ? 'text-gray-800' : 'text-gray-800 lg:text-gray-500'}`}
                  />
                  <p
                    className={`contact__icon ${isScrolled ? 'text-gray-800' : 'text-gray-800 lg:text-gray-500'}`}
                  >
                    {header.telefonoContacto}
                  </p>
                </div>
              )}
              {hasSocialNetworks && (
                <div className='flex items-center gap-1'>
                  <SocialLinks
                    socialNetworks={templateDate.socialNetworks}
                    className={isScrolled ? 'text-gray-800' : 'text-gray-800 lg:text-gray-500'}
                  />
                </div>
              )}
            </div>
            {!hideMobileNavMenu && (
              <div
                className='flex items-center justify-center'
              >
                <NavBarMobile isScrolled={isScrolled} />
              </div>
            )}
          </div>
        </div>
      </div>

      {!hideMobileNavMenu && (
        <div className='block lg:hidden pb-4'>
          <FeatureSelector />
        </div>
      )}
    </div>
  );
}
